<template>
    <div
        class="vld-parent"
        :class="{
            'container': !isMobile,
            'px-0': isMobile
        }"
    >
        <div
            class="start-search"
        >
            <b-img
                v-if="!!label.imagePath"
                :src="label.imagePath"
                :width="150"
            />
            <h2 class="mb-0">
                Nothing to see here!
            </h2>
            <h3 class="text-light-sm mb-4">
                {{ label.text }}
            </h3>
            <b-button
                class="start-search-button"
                size="lg"
                @click="displayMap"
            >
                Start Searching
            </b-button>
        </div>
    </div>
</template>

<script>
    import './PropertySearchStartSearching.scss';
    import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";
    import {
        CLEAR_FILTER_EVENT,
        PROPERTY_SEARCH_RESET
    } from "../GroupPropertySearchHeader/PropertySearchHeader/PropertySearchHeader";
    import {PROPERTY_SAVED_SEARCHES_DISPLAY_MAP} from "../GroupPropertySavedSearches/PropertySavedSearches";

    export default {
        name: "PropertyStartSearching",
        mixins: [IsMobileMixin],

        props: {
            label: {
                type: Object,
                default: () => {
                    return {
                        imagePath: '',
                        text: '',
                    };
                },
                validator: (object) => {
                    return object.hasOwnProperty('imagePath') && object.hasOwnProperty('text');
                }
            },
        },

        data() {
            return {

            };
        },

        methods: {

            displayMap() {
                this.$bus.$emit(CLEAR_FILTER_EVENT);
                this.$bus.$emit(PROPERTY_SEARCH_RESET);
                this.$bus.$emit(PROPERTY_SAVED_SEARCHES_DISPLAY_MAP);
            }
        },
    };
</script>
